import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

interface AlreadyTestedProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenResult?: () => void;
  onOtherChild?: () => void;
  onRestart?: () => void;
  onCloseApp?: () => void;
}

/**
 * M5 — «Уже проходили тест».
 *
 * Источник: UX-спека v1.2 раздел 3.4 + продуктовое решение Этапа 9.
 *
 * Phase 3 stage 3: 4 кнопки — «Открыть результат», «Пройти для другого
 * ребёнка», «Пройти заново», «Закрыть». Изоляция reset-семантик:
 *  - «Для другого ребёнка» — стирает child+ответы, сохраняет родителя
 *    (contacts + consents + city). Переход на /child-info.
 *  - «Пройти заново» — стирает только ответы/прогресс, сохраняет ребёнка
 *    и родителя. Переход на /instruction.
 *
 * До Phase 3 stage 3: было 3 кнопки (без «Для другого ребёнка»), «Заново»
 * делала полный reset через RESET action.
 *
 * Триггер: SessionContext useEffect после mount, если state.stage === 'done'
 * и state.completedAt !== null. Срабатывает только при ПОВТОРНОМ открытии
 * Mini App — в той же сессии M5 не выскочит (ref-guard в SessionContext).
 */
export function AlreadyTested({
  isOpen,
  onClose,
  onOpenResult,
  onOtherChild,
  onRestart,
  onCloseApp,
}: AlreadyTestedProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Тест уже пройден">
      <div className="flex flex-col gap-4 text-sm text-text-primary">
        <p>
          Можно открыть сохранённый результат, пройти тест для другого ребёнка
          или пройти заново.
        </p>
        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={onOpenResult ?? onClose} fullWidth>
            Открыть результат
          </Button>
          <Button onClick={onOtherChild ?? onClose} fullWidth variant="secondary">
            Пройти для другого ребёнка
          </Button>
          <Button onClick={onRestart ?? onClose} fullWidth variant="secondary">
            Пройти заново
          </Button>
          <Button onClick={onCloseApp ?? onClose} fullWidth variant="ghost" size="md">
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
}
